module.exports = __webpack_public_path__ + "media/images/icons/country_flags/pa-8659812291825552ed13c277d78a8968.svg";